import { getApiErrorMessage, getErrorStatusCode } from "shared/utils";
import type { ApiError } from "shared/utils";

export { getErrorStatusCode };

const FALLBACK_MESSAGES: Record<number, string> = {
  400: "Enter a valid phone number in international format, starting with +.",
  401: "Authorization required. Please sign in again.",
  409: "WhatsApp is already verified for this account. Contact support to change the phone number.",
  503: "Something went wrong on our side. Please try again in a moment.",
};

const DEFAULT_MESSAGE = "Something went wrong. Please try again.";

export const getWhatsappPhoneError = (error: ApiError): string | null =>
  getApiErrorMessage(error, FALLBACK_MESSAGES, DEFAULT_MESSAGE);
